module.exports = __webpack_public_path__ + "img/J11793.b532907e.png";